import { render } from "./InfoModal.vue?vue&type=template&id=65c454b7&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=65c454b7&lang=scss&scoped=true"
import "./InfoModal.vue?vue&type=style&index=1&id=65c454b7&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c454b7"]])

export default __exports__